import { UserType } from "../UserType";

export enum SignalingMessageType {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  USERNAME = "username",
  CHANGE_USERNAME = "change-username",
  USERLIST = "userlist",
  OFFER = "offer",
  ANSWER = "answer",
  CANDIDATE = "candidate"
}

export interface SignalingMessageOfferData {
  sdp: string;
  datetime: number;
  room: string;
}

export interface SignalingMessageAnswerData {
  sdp: string;
  datetime: number;
  room: string;
}

export interface SignalingMessageCandidateData {
  candidate: string;
  sdpMLineIndex: number;
  sdpMid: string;
  datetime: number;
  room: string;
}

export interface SignalingMessage<D = unknown> {
  type: SignalingMessageType;
  data: D;
  from?: number;
  to?: number;
}

export type SignalingMessageConnectData = {
  username: string;
  type: string;
  room: string;
};

export type SignalingMessageDisconnectData = {
  user: UserProps;
  room: string;
};

export type SignalingMessageDisconnect =
  SignalingMessage<SignalingMessageDisconnectData>;

export type SignalingMessageConnect =
  SignalingMessage<SignalingMessageConnectData>;

export type SignalingMessageConnectReplyData = {
  id: number;
};

export type SignalingMessageConnectReply =
  SignalingMessage<SignalingMessageConnectReplyData>;

export type SignalingMessageOffer = SignalingMessage<SignalingMessageOfferData>;

export type SignalingMessageAnswer =
  SignalingMessage<SignalingMessageAnswerData>;

export type SignalingMessageCandidate =
  SignalingMessage<SignalingMessageCandidateData>;

export type SignalingMessageUsernameData = {
  username: string;
  room: string;
  date: number;
  id: number;
};

export type SignalingMessageUsername =
  SignalingMessage<SignalingMessageUsernameData>;

export type SignalingMessageChangeUsername =
  SignalingMessage<SignalingMessageUsernameData>;

export type UserProps = {
  username: string;
  id: number;
  type: UserType;
};

export type SignalingMessageUserlistData = {
  room: string;
  users: UserProps[];
};

export type SignalingMessageChangedUsernameData = {
  room: string;
  user: UserProps;
};

export type SignalingMessageUserlist =
  SignalingMessage<SignalingMessageUserlistData>;

export type SignalingMessageChangedUsername =
  SignalingMessage<SignalingMessageChangedUsernameData>;
